import React from 'react';
import styled, { css } from 'styled-components';
import { useIntl } from 'react-intl';
import Spinner from './Spinner';
import { shadows, fontWeight, buttonDefaults } from '../style/tokens';

type ButtonVariant = 'start' | 'stop' | 'retry';

const Button = styled.button<{ variant: ButtonVariant }>`
  display: block;
  width: 100%;
  padding: 18px 0;
  border-radius: 50px;
  border: none;
  color: #fff;
  font-size: 17px;
  font-weight: ${fontWeight.bold};
  font-family: 'Outfit', sans-serif;
  text-align: center;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  background: ${({ theme }) => theme.coloreBottoneInattivo || buttonDefaults.inactive};
  @media (hover: hover) { &:hover { background: ${({ theme }) => theme.coloreBottoneAttivo || buttonDefaults.active}; } }
  &:active { background: ${({ theme }) => theme.coloreBottoneAttivo || buttonDefaults.active}; transform: scale(0.98); }
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
  @media (hover: hover) { &:disabled:hover { background: ${({ theme }) => theme.coloreBottoneInattivo || buttonDefaults.inactive}; } }
  &:disabled:active { transform: none; }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 14px 0;
`;

interface StartButtonProps {
  isLoading: boolean;
  isMeasuring: boolean;
  hasError: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const StartButton: React.FC<StartButtonProps> = ({
  isLoading,
  isMeasuring,
  hasError,
  disabled,
  onClick,
}) => {
  const intl = useIntl();

  if (isLoading) {
    return <SpinnerWrapper><Spinner /></SpinnerWrapper>;
  }

  if (isMeasuring) {
    return null;
  }

  return (
    <Button variant="start" onClick={onClick} disabled={disabled}>
      {hasError
        ? intl.formatMessage({ id: 'button.stop' })
        : intl.formatMessage({ id: 'button.startAnalysis' })}
    </Button>
  );
};

export default StartButton;
